require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/bundles/bundlesSidebar.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/bundles/bundlesSidebar.legacy.js
// module id = 702
// module chunks = 31